import { useQuery } from '@apollo/client';
import { useMemo } from 'react';

import { getOrganizationMemberUuids } from './check-organization-membership';
import { GET_SETTINGS_ORGANIZATION_MEMBERSHIP } from '../../../../queries/skill-administration';
import type { SettingsPeopleEligibility } from '../settings-people/people-picker';

export function useOrganizationPeopleEligibility(
  organizationUuid: string | null,
  enabled: boolean,
): SettingsPeopleEligibility {
  const shouldLoad = enabled && !!organizationUuid;
  const { data, loading, error, refetch } = useQuery(GET_SETTINGS_ORGANIZATION_MEMBERSHIP, {
    variables: { groupId: organizationUuid ?? '' },
    skip: !shouldLoad,
    fetchPolicy: 'no-cache',
    errorPolicy: 'none',
    notifyOnNetworkStatusChange: true,
    context: { queryDeduplication: false, notifications: { preventErrorNotification: true } },
  });
  const membership = useMemo(() => {
    if (!shouldLoad || loading) return {};
    try {
      if (error) throw error;
      return { allowedUserUuids: getOrganizationMemberUuids(data?.getSkillGroup, organizationUuid!) };
    } catch {
      return { error: "Couldn't load organization members." };
    }
  }, [data, error, loading, organizationUuid, shouldLoad]);

  return {
    ...membership,
    loading: shouldLoad && loading,
    retry: () => void refetch().catch(() => undefined),
  };
}
